// extracted by mini-css-extract-plugin
module.exports = {"default-div":"InnerMargin_default-div__pN_6J","center-div":"InnerMargin_center-div__JQS7y"};